<template>
  <div v-if="canEdit" class="d-flex bg-white justify-content-center gap-10 align-items-center">

    <div class="p-0 m-0 position-relative shadow-sm h-100 w-100">
      <div class="card shadow-none">
        <div class="card-header">
          <div class="card-toolbar">
            <Button btn-class="btn-sm btn-icon me-2" type="button" icon-class="fa fa-edit text-primary" @click.prevent="editTemplate(template.face?.template_id)"/>
          </div>
        </div>
        <div class="card-body p-0 m-0">
          <iframe class="badge-wrapper" :srcdoc="template.face?.content" frameborder="0" style="width: 100%; min-height: 700px"></iframe>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <iframe :srcdoc="template" frameborder="0" style="width: 100%; min-height: 700px"></iframe>
  </div>

</template>

<script setup>
import QRCodeVue3 from 'qrcode-vue3';
import { onBeforeMount, onMounted, ref, watch } from 'vue';
import Button from "@/components/Button.vue";
import { useRouter } from "vue-router"

const router = useRouter()
const props = defineProps({
  participator: {type: Object, default:{
        firstname: "ALLISOUTIN",
        lastname: "Agnès",
        post: "Manager Adjointe de la prod",
        company: "Netbyus",
        type: "Conférencière"
    }},
  canEdit: { type: Boolean, default: false },
  template: {
    type: Object,
    required: true,
    default: () => ({})
  }
    
})

const qrSize = ref(300)

watch(() => props.participator, (value) => {
  if(value.lastname && value.firstname) {
    props.template.face.content.replace('{{FIRSTNAME}}', value.firstname)
  }
}, { deep: true })

const updateQrSize = () => {
  qrSize.value = window.innerWidth < 768 ? 200 : 350
}

function editTemplate(id) {
  const url = router.resolve({ name: "template-builder", params: { id } }).href;
  window.open(url, '_blank');
}

onMounted(() => {
  updateQrSize()
  window.addEventListener('resize', updateQrSize)
})

onBeforeMount(() => {
  window.removeEventListener('resize', updateQrSize)
})


</script>
<style >

.bottom-border{
    border-bottom: 3px solid;
    border-color: var(--bs-primary);
}

.rounded-qr{
    border-radius: 15px;
    border: 3px solid var(--bs-primary);
}

.rounded-img-qr{
    border-radius: 15px;
    height: 45%;
    width: auto;
}

.custom-bg {
  width: 35%;
  background-image: url('/public/assets/media/background.jpg');
  background-size: cover;             /* ou contain selon ton besoin */
  background-position: center center; /* ou top left, bottom right, etc. */
  background-repeat: no-repeat;
}

</style>